import GettingStartedPage from '@/modules/getting_started/GettingStartedPage';

export default [
  {
    path: '/getting-started',
    name: 'getting-started',
    component: GettingStartedPage,
    props: true,
    meta: {
      title: 'Getting Started',
      bypassOrgCheck: true
    }
  }
];
